import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./productPageStyle.js";

const useStyles = makeStyles(styles);

/**
 * HU/EN switch for the record page.
 *
 * It lives in the page rather than the header because the site-wide header is
 * English-only and shared with every other page — this page is the one that is
 * bilingual, so the control belongs to it.
 */
export default function LangToggle({ t, onToggle }) {
  const classes = useStyles();

  return (
    <button
      type="button"
      className={classes.langToggle}
      onClick={onToggle}
      aria-label={t.langOther}
    >
      <span className={classes.langOn}>{t.langCurrent}</span>
      <span className={classes.langOff}>{t.langOther}</span>
    </button>
  );
}
